export default {
  breakHeight: '1rem',
};
